import React from "react";
import { JOB_STATES_DISPLAY } from "../../../../utils/constants";
import ProcessingJobServicesTable from "./ProcessingJobServicesTable";

const JobServicesByStateTable = ({
  jobServices,
  setJobServices,
  reloadData
}) => {
  const jobServicesStates = _.isEmpty(jobServices) ? [] : Object.keys(jobServices).sort()

  jobServicesStates.sort((a, b) => {
    const priority = ["unprocessed_from_navvis", "processing_in_navvis", "processing_in_3d"];
    const aIndex = priority.indexOf(a);
    const bIndex = priority.indexOf(b);

    return (aIndex === -1 ? 999 : aIndex) - (bIndex === -1 ? 999 : bIndex);
  });

  return (
    <>
      {jobServicesStates.map(state => {
        const jobServicesOfState = jobServices[state]
        const jobStateDisplay = JOB_STATES_DISPLAY[state]?.text
        return (
          (!!jobServicesOfState?.length && (
            <div key={`date-${state}`}>
              <h3 className="text-dark pt-5">{jobStateDisplay}</h3>
              <ProcessingJobServicesTable
                jobServices={jobServicesOfState}
                setJobServices={setJobServices}
                reloadData={reloadData} />
            </div>
          ))
        )
      })}
    </>
  )
}

export default JobServicesByStateTable